const RouteState = { render: () => null };

const telephonyRoute = (path, name, telephonyTab) => ({
  path,
  name,
  component: RouteState,
  meta: { adminTab: 'Telephony', telephonyTab },
});

export const TELEPHONY_ROUTES = [
  telephonyRoute('telephony', 'AdminTelephony', 'call_logs'),
  telephonyRoute('telephony/call-logs', 'AdminTelephonyCallLogs', 'call_logs'),
  telephonyRoute('telephony/phone-numbers', 'AdminTelephonyPhoneNumbers', 'phone_numbers'),
];
